import React from 'react';
import { Card, Title, Group, Loader, Button, Box } from '@mantine/core';
import { DashboardCardProps } from '../types/dashboard.types';

export const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  icon,
  children,
  className,
  onLoadMore,
  hasMore,
  isLoading,
  headerActions,
  noPadding
}) => {
  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder className={className}>
      <Card.Section withBorder inheritPadding py="xs">
        <Group justify="apart">
          <Group gap="xs">
            {icon}
            <Title order={4}>{title}</Title>
          </Group>
          {headerActions && (
            <Group gap="xs">
              {headerActions}
            </Group>
          )}
        </Group>
      </Card.Section>

      <Card.Section inheritPadding={!noPadding} mt={noPadding ? 0 : "sm"} pb={noPadding ? 0 : "md"}>
        {isLoading ? (
          <Box style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
            <Loader size="sm" />
          </Box>
        ) : (
          <>
            {children}
            {hasMore && onLoadMore && (
              <Button
                variant="subtle"
                fullWidth
                mt="md"
                onClick={onLoadMore}
              >
                Show More...
              </Button>
            )}
          </>
        )}
      </Card.Section>
    </Card>
  );
};
